import React, { useEffect } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ResidentialPage } from './pages/ResidentialPage';
import { ResortsPage } from './pages/ResortsPage';
import { DevelopersPage } from './pages/DevelopersPage';
import { ActivationsPage } from './pages/ActivationsPage';
import { SignatureConceptsPage } from './pages/SignatureConceptsPage';
import { PuttLabPlayPage } from './pages/PuttLabPlayPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PlayApp } from './pages/PlayApp';
import { PlayAnalyticsPage } from './pages/PlayAnalyticsPage';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <HashRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        {/* Standalone App Route (No Layout/Nav/Footer) */}
        <Route path="/play/app" element={<PlayApp data-id="element-4" />} data-id="element-3" />

        {/* Main Website Routes (Wrapped in Layout) */}
        <Route path="*" element={<Layout data-id="element-6">
              <Routes data-id="element-7">
                <Route path="/" element={<HomePage data-id="element-9" />} data-id="element-8" />
                <Route path="/residential" element={<ResidentialPage data-id="element-11" />} data-id="element-10" />
                <Route path="/resorts" element={<ResortsPage data-id="element-13" />} data-id="element-12" />
                <Route path="/developers" element={<DevelopersPage data-id="element-15" />} data-id="element-14" />
                <Route path="/activations" element={<ActivationsPage data-id="element-17" />} data-id="element-16" />
                <Route path="/concepts" element={<SignatureConceptsPage data-id="element-19" />} data-id="element-18" />
                <Route path="/play" element={<PuttLabPlayPage data-id="element-21" />} data-id="element-20" />
                <Route path="/play/analytics" element={<PlayAnalyticsPage data-id="element-23" />} data-id="element-22" />
                <Route path="/about" element={<AboutPage data-id="element-25" />} data-id="element-24" />
                <Route path="/contact" element={<ContactPage data-id="element-27" />} data-id="element-26" />
              </Routes>
            </Layout>} data-id="element-5" />
      </Routes>
    </HashRouter>;
}